
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/daymade-has-planted-1-million-trees",
      function () {
        return require("private-next-pages/blog/daymade-has-planted-1-million-trees.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/daymade-has-planted-1-million-trees"])
      });
    }
  